// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from 'firebase/database';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const GOOGLE_APPLICATION_CREDENTIALS =   {
  "type": process.env.REACT_APP_GOOGLE_TYPE,
  "project_id": process.env.REACT_APP_GOOGLE_PROJECT_ID,
  "private_key_id": process.env.REACT_APP_GOOGLE_PRIVATE_KEY_ID,
  "private_key":  process.env.REACT_APP_GOOGLE_PRIVATE_KEY,
  "client_email":  process.env.REACT_APP_GOOGLE_CLIENT_EMAIL,
  "client_id":  process.env.REACT_APP_GOOGLE_CLIENT_ID,
  "auth_uri": process.env.REACT_APP_GOOGLE_AUTH_URI,
  "token_uri": process.env.REACT_APP_GOOGLE_TOKEN_URI,
  "auth_provider_x509_cert_url": process.env.REACT_APP_GOOGLE_AUTH_PROVIDER_X509_CERT_URL,
  "client_x509_cert_url":  process.env.REACT_APP_GOOGLE_CLIENT_X509_CERT_URL,
}


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Realtime Database
export const db = getDatabase(app);

